import Common from "../Common";

const Verify = class extends Common {
	exchangeAlias = (userId: id, token: string) =>
		this.get(`/verify/exchangealias/${userId}`, { token })

	exchangeAliasExtend = (userId: id) =>
		this.get(`/verify/exchangealias/${userId}/extend`)
}

export default Verify
